import { defineMessages } from "@/i18n";
import en from "./en";

export const agentActivityProgressMessages = defineMessages(
  "agent-activity-progress",
  en,
);
